(() => {
  if (window.__ortluxCookieSettings) return;
  window.__ortluxCookieSettings = true;
  document.addEventListener('click', async (event) => {
    const link = event.target.closest('a[data-ortlux-cookie-settings]');
    if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const status = link.parentElement.querySelector('[data-cookie-settings-status]');
    if (!window.privacyBanner?.showPreferences) {
      if (status) status.textContent = 'Cookie settings are not ready. Please reload this page and try again.';
      return;
    }
    event.preventDefault();
    if (status) status.textContent = '';
    try { await window.privacyBanner.showPreferences(); }
    catch (_) {
      if (status) status.textContent = 'Cookie settings could not open. Please reload this page and try again.';
      link.focus();
    }
  });
})();
